import { Builder } from '@builder.io/react';
import Testimonials from './Testimonials';

Builder.registerComponent(Testimonials, {
  name: 'Testimonials',
  inputs: [
    {
      name: 'autoplay',
      type: 'boolean',
      defaultValue: true,
      helperText: 'When enabled, the carousel scrolls automatically.'
    },
    {
      name: 'autoplaySpeed',
      type: 'number',
      defaultValue: 5,
      helperText: 'Duration, in seconds, of how long each quote is displayed before moving to the next. NOTE: refresh page after enabling to see effect.'
    },
    {
      name: 'showDots',
      type: 'boolean',
      defaultValue: true,
      helperText: 'Show navigation dots underneath quotes.'
    },
  ],
});
